import { Component } from '@angular/core';
import { BoletoService } from '../../services/boleto.service';
@Component({
  selector: 'app-boleto',
  templateUrl: './boleto.component.html',
  styleUrls: ['./boleto.component.css']
})
export class BoletoComponent {
  boletos: any;
  loading: boolean = false;
  constructor(private boletoService: BoletoService) {
    this.loading = true;
    this.boletoService.getAllBoletos().subscribe((res: any) => {
      this.boletos = res.boletos;
      this.loading = false;
    });
  }
}
